webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(107);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueMaterial = __webpack_require__(106);
	
	var _vueMaterial2 = _interopRequireDefault(_vueMaterial);
	
	var _vuefire = __webpack_require__(108);
	
	var _vuefire2 = _interopRequireDefault(_vuefire);
	
	var _App = __webpack_require__(93);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueMaterial2.default);
	_vue2.default.use(_vuefire2.default);
	
	new _vue2.default({
	  el: '#app',
	  components: {
	    App: _App2.default
	  },
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    ViewComponent: function ViewComponent() {
	      return _App2.default;
	    }
	  },
	  render: function render(h) {
	    return h(this.ViewComponent);
	  }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addTraining = exports.watchLogin = exports.logout = exports.login = undefined;
	
	var _firebase = __webpack_require__(34);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  apiKey: 'AIzaSyBUBlF_4lvilWfHXRDv2x5uUx_l71zZ3MU',
	  authDomain: 'conuhacks2017.firebaseapp.com',
	  databaseURL: 'https://conuhacks2017.firebaseio.com',
	  storageBucket: 'conuhacks2017.appspot.com',
	  messagingSenderId: '411746442942'
	};
	_firebase2.default.initializeApp(config);
	
	var provider = new _firebase2.default.auth.FacebookAuthProvider();
	var db = _firebase2.default.database();
	
	var login = function login() {
	  return _firebase2.default.auth().signInWithPopup(provider);
	};
	
	var logout = function logout() {
	  return _firebase2.default.auth().signOut();
	};
	
	window.firebase = _firebase2.default;
	var watchLogin = function watchLogin(x) {
	  return _firebase2.default.auth().onAuthStateChanged(function (data) {
	    return x(data);
	  });
	};
	
	var trainingsRef = db.ref().child('trainings');
	
	var addTraining = function addTraining(userId) {
	  return trainingsRef.push({
	    userId: userId,
	    state: 'recording',
	    count: 0
	  });
	};
	
	exports.login = login;
	exports.logout = logout;
	exports.watchLogin = watchLogin;
	exports.addTraining = addTraining;

/***/ },
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(83)
	
	/* script */
	__vue_exports__ = __webpack_require__(41)
	
	/* template */
	var __vue_template__ = __webpack_require__(99)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(45);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(46);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(47);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _firebase = __webpack_require__(34);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var constraints = {
	  audio: true,
	  video: false
	};
	
	var generateUID = function generateUID() {
	  return '_' + Math.random().toString(36).substr(2, 9);
	};
	
	var _class = function () {
	  function _class() {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var isSecureOrigin = window.location.protocol === 'https:' || window.location.hostname === 'localhost';
	    if (!isSecureOrigin) {
	      window.alert('getUserMedia() must be run from a secure origin: HTTPS or localhost.' + '\n\nChanging protocol to HTTPS');
	      window.location.protocol = 'HTTPS';
	    }
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
	          console.log('getUserMedia() got stream: ', stream);
	          _this.stream = stream;
	          resolve();
	        }).catch(function (error) {
	          console.log('navigator.getUserMedia error: ', error);
	          reject();
	        });
	      });
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      var _this2 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        _this2.recordedBlobs = [];
	        try {
	          _this2.mediaRecorder = new MediaRecorder(_this2.stream, { mimeType: 'audio/webm' });
	        } catch (e) {
	          console.error('Exception while creating MediaRecorder (audio/wav): ' + e);
	          reject(e);
	        }
	        console.log('Created MediaRecorder with wav');
	        _this2.mediaRecorder.onstop = function () {
	          console.log('Record stopped');
	        };
	        _this2.mediaRecorder.ondataavailable = function (event) {
	          if (event.data && event.data.size > 0) {
	            _this2.recordedBlobs.push(event.data);
	          }
	        };
	        _this2.mediaRecorder.start(10);
	        console.log('MediaRecorder started', _this2.mediaRecorder);
	        resolve();
	      });
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var _this3 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        _this3.mediaRecorder.stop();
	        var blob = new Blob(_this3.recordedBlobs, { type: 'audio/wav' });
	        var storage = _firebase2.default.storage();
	        var space = storage.ref().child('words');
	        var fileName = generateUID();
	        var task = space.child(fileName).put(blob);
	        task.on('state_changed', function () {}, function (e) {
	          reject(e);
	        }, function () {
	          resolve(task.snapshot.downloadURL);
	        });
	      });
	    }
	  }]);
	  return _class;
	}();

	exports.default = _class;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Register = __webpack_require__(97);
	
	var _Register2 = _interopRequireDefault(_Register);
	
	var _Setup = __webpack_require__(98);
	
	var _Setup2 = _interopRequireDefault(_Setup);
	
	var _Activation = __webpack_require__(94);
	
	var _Activation2 = _interopRequireDefault(_Activation);
	
	var _Authentication = __webpack_require__(95);
	
	var _Authentication2 = _interopRequireDefault(_Authentication);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Register: _Register2.default,
	    Setup: _Setup2.default,
	    Activation: _Activation2.default,
	    Authentication: _Authentication2.default
	  },
	  data: function data() {
	    return {
	      user: null,
	      currentRoute: window.location.pathname
	    };
	  },
	
	  methods: {
	    onLogin: function onLogin(user) {
	      this.user = user;
	      this.currentRoute = '/setup';
	    }
	  },
	  computed: {
	    userId: function userId() {
	      return this.user ? this.user.user.uid : '';
	    },
	    displayName: function displayName() {
	      return this.user ? this.user.user.displayName : '';
	    },
	    isRegister: function isRegister() {
	      return this.currentRoute === '/register';
	    },
	    isActivation: function isActivation() {
	      return this.currentRoute === '/activation';
	    },
	    isAuthentication: function isAuthentication() {
	      return this.currentRoute === '/authentication';
	    },
	    isSetup: function isSetup() {
	      return this.currentRoute === '/setup';
	    }
	  }
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Activation',
	  data: function data() {
	    return {
	      active: false,
	      activatedColor: 'green'
	    };
	  },
	  methods: {
	    onActivate: function onActivate(event) {
	      window.alert('YOU PRESSED A BUTTON!');
	    }
	  }
	};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecordButton = __webpack_require__(35);
	
	var _RecordButton2 = _interopRequireDefault(_RecordButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Authenticate',
	  components: {
	    RecordButton: _RecordButton2.default
	  },
	  data: function data() {
	    return {
	      choice: 'text',
	      message: null,
	      voice: null
	    };
	  },
	
	  methods: {
	    toggleThing: function toggleThing(event) {
	      this.choice = this.choice === 'text' ? 'voice' : 'text';
	    },
	    onSubmit: function onSubmit(event) {
	      window.alert('YOU PRESSED A BUTTON!');
	    },
	    onRecord: function onRecord(event) {
	      window.alert(event);
	    }
	  }
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _db = __webpack_require__(22);
	
	exports.default = {
	  data: function data() {
	    return {
	      user: null
	    };
	  },
	
	  methods: {
	    onClickLogin: function onClickLogin() {
	      var _this = this;
	
	      (0, _db.login)().then(function (x) {
	        _this.user = x;
	        _this.$emit('login', x);
	      });
	    },
	    onClickLogout: function onClickLogout() {
	      var _this2 = this;
	
	      (0, _db.logout)().then(function (x) {
	        _this2.user = null;
	        _this2.$emit('logout');
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    (0, _db.watchLogin)(function (authData) {
	      if (authData) {
	        console.log('User ' + authData.uid + ' is logged');
	        _this3.user = authData;
	        _this3.$emit('login', { user: authData });
	      } else {
	        console.log('User is logged out');
	        _this3.$emit('logout');
	      }
	    });
	  }
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mic = __webpack_require__(36);
	
	var _mic2 = _interopRequireDefault(_mic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      initialized: false,
	      recording: false
	    };
	  },
	  computed: {
	    buttonCls: function buttonCls() {
	      if (this.recording) {
	        return 'md-raised simple-transition md-accent';
	      } else {
	        return 'md-raised simple-transition md-primary';
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.$mic = new _mic2.default();
	    this.init();
	  },
	
	  methods: {
	    onClickMic: function onClickMic() {
	      if (this.recording) {
	        this.stop();
	      } else {
	        this.start();
	      }
	    },
	    init: function init() {
	      var _this = this;
	
	      this.$mic.init().then(function () {
	        _this.initialized = true;
	      }).catch(function () {
	        _this.initialized = false;
	      });
	    },
	    start: function start() {
	      var _this2 = this;
	
	      this.$mic.start().then(function () {
	        _this2.recording = true;
	      }).catch(function (e) {
	        _this2.recording = false;
	        window.alert(e);
	      });
	    },
	    stop: function stop() {
	      var _this3 = this;
	
	      this.$mic.stop().then(function (url) {
	        _this3.recording = false;
	        _this3.$emit('recorded', url);
	      }).catch(function (e) {
	        _this3.recording = false;
	        window.alert(e);
	      });
	    }
	  }
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LoginButton = __webpack_require__(96);
	
	var _LoginButton2 = _interopRequireDefault(_LoginButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Register',
	  methods: {
	    onLogin: function onLogin(user) {
	      this.$emit('login', user);
	    }
	  },
	  components: {
	    LoginButton: _LoginButton2.default
	  }
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecordButton = __webpack_require__(35);
	
	var _RecordButton2 = _interopRequireDefault(_RecordButton);
	
	var _db = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Setup',
	  props: ['userId', 'displayName'],
	  components: { RecordButton: _RecordButton2.default },
	  data: function data() {
	    return {
	      connected: false,
	      name: this.displayName ? this.displayName : '',
	      phoneNumber: null,
	      emergencyNumber: null,
	      status: 'Waiting for input',
	      activateNext: ''
	    };
	  },
	
	  methods: {
	    onSubmit: function onSubmit(event) {
	      window.alert('YOU PRESSED SUBMIT');
	    },
	    onRecorded: function onRecorded(fileUrl) {
	      console.log(fileUrl);
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.userId !== '') {
	      (0, _db.addTraining)(this.userId).then(function (r) {
	        _this.connected = true;
	        _this.$bindAsObject('training', r);
	      });
	    }
	  },
	
	  computed: {
	    allowNext: function allowNext() {
	      return this.training && this.training.count >= 5;
	    },
	
	    statusCheck: function statusCheck() {
	      this.status = this.counter === 5 ? 'Working' : this.status;
	      return this.status;
	    },
	    nextCheck: function nextCheck() {
	      this.activateNext = this.counter === 5 ? '' : 'disabled';
	      return this.activateNext;
	    },
	    buttonTextCheck: function buttonTextCheck() {
	      this.buttonText = this.counter === 5 ? 'NEXT' : 'TRAIN';
	      return this.buttonText;
	    }
	  }
	};

/***/ },
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 84 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 85 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 86 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 87 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 88 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(87)
	
	/* script */
	__vue_exports__ = __webpack_require__(37)
	
	/* template */
	var __vue_template__ = __webpack_require__(104)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(84)
	
	/* script */
	__vue_exports__ = __webpack_require__(38)
	
	/* template */
	var __vue_template__ = __webpack_require__(100)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(86)
	
	/* script */
	__vue_exports__ = __webpack_require__(39)
	
	/* template */
	var __vue_template__ = __webpack_require__(103)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(88)
	
	/* script */
	__vue_exports__ = __webpack_require__(40)
	
	/* template */
	var __vue_template__ = __webpack_require__(105)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(42)
	
	/* template */
	var __vue_template__ = __webpack_require__(101)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(85)
	
	/* script */
	__vue_exports__ = __webpack_require__(43)
	
	/* template */
	var __vue_template__ = __webpack_require__(102)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 99 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.initialized) ? _c('md-button', {
	    class: _vm.buttonCls,
	    on: {
	      "click": _vm.onClickMic
	    }
	  }, [_c('md-icon', {
	    staticClass: "md-size-4x"
	  }, [_vm._v("mic")])], 1) : _c('div', [_vm._v("\n  There's no mic available on this device.\n")])
	},staticRenderFns: []}

/***/ },
/* 100 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('md-card', {
	    staticClass: "activation-container"
	  }, [(_vm.active) ? _c('h1', {
	    staticStyle: {
	      "color": "green"
	    }
	  }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (!_vm.active) ? _c('h1', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("Deactivated")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tDisactivated\n\t\t\t\t\t"), _c('md-switch', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.active),
	      expression: "active"
	    }],
	    attrs: {
	      "md-theme": "green",
	      "id": "my-test5",
	      "name": "my-test5"
	    },
	    domProps: {
	      "value": (_vm.active)
	    },
	    on: {
	      "change": _vm.onActivate,
	      "input": function($event) {
	        _vm.active = $event
	      }
	    }
	  }), _vm._v("\n\t\t\t\t\tActivated\n\t\t")], 1)])
	},staticRenderFns: []}

/***/ },
/* 101 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('login-button', {
	    on: {
	      "login": _vm.onLogin
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 102 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('md-card', {
	    staticClass: "setup-container"
	  }, [_c('form', {
	    attrs: {
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        _vm.submit($event)
	      }
	    }
	  }, [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Setup, when you initially need to setup voice + string authentication")])]), _vm._v(" "), _c('record-button', {
	    on: {
	      "recorded": _vm.onRecorded
	    }
	  }), _vm._v(" "), (_vm.connected) ? _c('div', [_vm._v(" " + _vm._s(_vm.training.count) + " / 5 ")]) : _vm._e(), _vm._v(" "), (_vm.connected) ? _c('md-button', {
	    staticClass: "md-raised"
	  }, [_vm._v("Status: " + _vm._s(_vm.training.state))]) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Your name")]), _vm._v(" "), _c('md-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    attrs: {
	      "placeholder": "Your name"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        _vm.name = $event
	      }
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("What's your numbah?")]), _vm._v(" "), _c('md-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.phoneNumber),
	      expression: "phoneNumber"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.phoneNumber)
	    },
	    on: {
	      "input": function($event) {
	        _vm.phoneNumber = _vm._n($event)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("What's your emergency contact numbah?")]), _vm._v(" "), _c('md-input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.emergencyNumber),
	      expression: "emergencyNumber"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.emergencyNumber)
	    },
	    on: {
	      "input": function($event) {
	        _vm.emergencyNumber = _vm._n($event)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })], 1), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-primary",
	    attrs: {
	      "disabled": !_vm.allowNext
	    }
	  }, [_vm._v("Next")])], 1)])
	},staticRenderFns: []}

/***/ },
/* 103 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('md-card', {
	    staticClass: "auth-view"
	  }, [_c('img', {
	    staticStyle: {
	      "margin": "0 auto",
	      "display": "block",
	      "width": "100%"
	    },
	    attrs: {
	      "src": "https://pbs.twimg.com/media/CPB2xJ9WcAAK0G6.jpg"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', [_vm._v("Say the password")]), _vm._v(" "), _c('record-button', {
	    on: {
	      "recorded": _vm.onRecord
	    }
	  }), _vm._v(" "), _c('br')], 1)
	},staticRenderFns: []}

/***/ },
/* 104 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('md-tabs', {
	    attrs: {
	      "md-fixed": ""
	    }
	  }, [_c('md-tab', {
	    attrs: {
	      "id": "Register",
	      "md-label": "Register",
	      "md-active": _vm.isRegister
	    }
	  }, [_c('register', {
	    on: {
	      "login": _vm.onLogin
	    }
	  })], 1), _vm._v(" "), _c('md-tab', {
	    attrs: {
	      "id": "Setup",
	      "md-label": "Setup",
	      "md-active": _vm.isSetup
	    }
	  }, [_c('setup', {
	    key: _vm.userId,
	    attrs: {
	      "userId": _vm.userId,
	      "displayName": _vm.displayName
	    }
	  })], 1), _vm._v(" "), _c('md-tab', {
	    attrs: {
	      "id": "Activation",
	      "md-label": "Activation",
	      "md-active": _vm.isActivation
	    }
	  }, [_c('activation')], 1), _vm._v(" "), _c('md-tab', {
	    attrs: {
	      "id": "Authentication",
	      "md-label": "Authentication",
	      "md-active": _vm.isAuthentication
	    }
	  }, [_c('authentication')], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 105 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.user) ? _c('md-button', {
	    on: {
	      "click": _vm.onClickLogin
	    }
	  }, [_vm._v("Login")]) : _c('md-button', {
	    on: {
	      "click": _vm.onClickLogout
	    }
	  }, [_vm._v("Logout")])
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.9e2e272c41fe358dd7e1.js